import { myFetchRequestApi } from '@/http/my-fetch';
import type { CreateOrderParams, OrderDetailAo } from '@/apis/order/model/index';
import { convertOrderAoToLo, convertOrderSystemAoToLo } from '@/apis/order/model/index';
import type { PaymentGetUrlParams } from '@/logic/order/model';
enum Api {
	cmsService = 'cmsService',
	orderService = 'orderService',
	refundService = 'refundService',
	orderSystemService = 'orderSystemService',
	getOrderDetailUrl = '/rest/order/get',
	getOrderListUrl = '/rest/order/list',
	saveCreateOrderUrl = '/PolarisOrder/create/order',
	getPayChannelUrl = '/PolarisOrderSystem/pay/getPayChannel',
	getManualPayChannelUrl = '/PolarisOrderSystem/pay/getManualAuxPayChannel',
	getManualPaymentUrl = '/PolarisOrderSystem/pay/getManualAuxOrderPayUrl',
	getRefundPayChannelUrl = '/refundsystem/pay/getSchedulePayChannel',
	getRefundPaymentUrl = '/refundsystem/pay/getSchedulePayUrl',
	getPaymentUrl = '/PolarisOrderSystem/pay/getPayUrl',
	getPayLocalUrl = '/PolarisOrderSystem/pay/getLocal',
	checkPaymentStatusUrl = '/PolarisOrderSystem/pay/checkStatus',
	getPayCheckStatusSee = 'PolarisOrderSystem/pay/getPayStatusSse'
}
// 获取订单列表数据start
export const getOrderListApi = async (params: { data: string | undefined, pageNum: number, pageSize: number; }) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.getOrderListUrl,
		{
			method: 'POST',
			params
		});
	return res;
};
// 获取订单列表数据end
// 获取订单详情数据start
export const getOrderDetailApi = async (params: { id: string; }) => {
	const res = await myFetchRequestApi<OrderDetailAo>(
		Api.cmsService,
		true,
		Api.getOrderDetailUrl,
		{
			method: 'POST',
			params
		});
	return convertOrderAoToLo(res.data);
};
// 获取订单详情数据end
// 获取国家二字码
export const getPatLocalApi = async () => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getPayLocalUrl,
		{
			method: 'GET',
		});
	return res;
};
// 改签行李支付通道获取接口
export const getRefundPayChannelUrlApi = async (params: { uuid: string; }) => {
	const res = await myFetchRequestApi(
		Api.refundService,
		true,
		Api.getRefundPayChannelUrl,
		{
			method: 'POST',
			params
		});
	return convertOrderSystemAoToLo(res.data);
};
// 手工行李获取支付通道
export const getManualPayChannelUrlApi = async (params: { uuid: string; }) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getManualPayChannelUrl,
		{
			method: 'POST',
			params
		});
	return convertOrderSystemAoToLo(res.data);
};
// 订单获取支付通道接口start
export const getPayChannelApi = async (params: { cid: string; sessionId: string; orderId: number; currency: string; deviceType: string; belongArea: string; amount: number; }) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getPayChannelUrl,
		{
			method: 'POST',
			params
		});
	return convertOrderSystemAoToLo(res.data);
};
// 订单支付接口end
// 改签行李获取支付链接
export const getRefundPaymentUrlApi = async (params: { cid: string, uuid?: string; fazId: number; payInfo?: string; }) => {
	const res = await myFetchRequestApi(
		Api.refundService,
		true,
		Api.getRefundPaymentUrl,
		{
			method: 'POST',
			params
		});
	return res;
};
// 手工行李获取支付链接
export const getManualPaymentUrlApi = async (params: { cid: string, uuid?: string; fazId: number; payInfo?: string; }) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getManualPaymentUrl,
		{
			method: 'POST',
			params
		});
	return res;
};
// 获取支付链接
export const getPaymentUrlApi = async (params: PaymentGetUrlParams) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getPaymentUrl,
		{
			method: 'POST',
			params
		});
	return res;
};
// 生单接口
export const saveCreateOrderApi = async (params: CreateOrderParams) => {
	const res = await myFetchRequestApi(
		Api.orderService,
		true,
		Api.saveCreateOrderUrl,
		{
			method: 'POST',
			params
		});
	return res;
};

// 支付状态查询
export const checkPaymentStatusApi = async (params: { channelTradeNo: string; }) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.checkPaymentStatusUrl,
		{
			method: 'GET',
			params
		});
	return res;
};
// see轮询
export const getPayCheckStatusSeeApi = async (params: { channelTradeNo: string; }) => {
	const res = await myFetchRequestApi(
		Api.orderSystemService,
		true,
		Api.getPayCheckStatusSee,
		{
			method: 'GET',
			params
		});
	return res;
};